export const banner = {
  cover: 'https://img.alicdn.com/tfs/TB1RbLZiFY7gK0jSZKzXXaikpXa-3840-1258.png',
  mcover: 'https://gw.alicdn.com/tfs/TB1RbLZiFY7gK0jSZKzXXaikpXa-3840-1258.png',
  title: '关于我们',
};

export const about = {
  img: 'https://img.alicdn.com/tfs/TB1OPMhjuH2gK0jSZFEXXcqMpXa-4212-2178.png',
  title: '关于扁鹊',
  content: [
    {
      text:
        '浙江扁鹊健康科技有限公司成立于2018年3月，系阿里巴巴集团旗下阿里健康和蚂蚁金服共同投资设立。基于阿里巴巴集团先进的云计算和大数据技术能力，丰富的互联网行业运营经验，通过医疗健康信息与云计算、大数据、人工智能等领域的深度结合，探索医疗健康新型服务，促进产业链上下游直径的信息流动、业务协同和互联互通。同时，在卫生服务、行政监管、便民体验等领域，借助阿里的互联网运营经验和入口优势提供多种应用服务。',
    },
    {
      text:
        '其主要业务包含：全流程刷脸就医、浙江省居民电子健康卡、健康医疗数据平台、浙江省互联网医院平台、智慧服务等。',
    },
  ],
  approveData: [
    {
      img: 'https://img.alicdn.com/tfs/TB11rjiirj1gK0jSZFOXXc7GpXa-668-976.png',
      title: '信息技术',
    },
    {
      img: 'https://img.alicdn.com/tfs/TB1yrHdiED1gK0jSZFGXXbd3FXa-688-976.png',
      title: '环境管理',
    },
    {
      img: 'https://img.alicdn.com/tfs/TB1RUnciEH1gK0jSZSyXXXtlpXa-688-976.png',
      title: '信息安全',
    },
    {
      img: 'https://img.alicdn.com/tfs/TB15JndiET1gK0jSZFhXXaAtVXa-690-976.png',
      title: '质量管理',
    },
  ],
  lineLeft: {
    img: 'https://img.alicdn.com/tfs/TB1IPqDip67gK0jSZPfXXahhFXa-306-308.png',
    text: '左边线',
  },
  lineRight: {
    img: 'https://img.alicdn.com/tfs/TB1FjzeiAY2gK0jSZFgXXc5OFXa-316-316.png',
    text: '右边线',
  },
};

export const culture = {
  title: '扁鹊文化',
  img: 'https://img.alicdn.com/tfs/TB1QY_2iHr1gK0jSZR0XXbP8XXa-1472-964.png',
  belief: [
    {
      text: '客户第一：客户是衣食父母',
    },
    {
      text: '团队合作：共享共担，平凡人做非凡事',
    },
    {
      text: '拥抱变化：迎接变化，勇于创新',
    },
    {
      text: '诚信：诚实正直，言行坦荡',
    },
    {
      text: '激情：乐观向上，永不放弃',
    },
    {
      text: '敬业：专业执着，精益求精',
    },
  ],
};

export const contact = {
  title: '联系我们',
  imgUrl: 'https://img.alicdn.com/tfs/TB1UVDFqX67gK0jSZPfXXahhFXa-874-578.jpg',
  text: [
    '联系电话：4008558517',
    '商务联系：李先生',
    '公司地址：浙江省杭州市余杭区文一西路和绿汀路交叉口浙富西溪堂1号楼',
  ],
};
